import { createWithEqualityFn as create } from 'zustand/traditional';

const STORAGE_KEY = 'HUB_RESUME_CREDENTIALS';

export type ResumeCredentials = {
  connectionId: string;
  resumeToken: string;
};

type HubResumeState = {
  credentials: ResumeCredentials | undefined;
  setCredentials: (credentials: ResumeCredentials) => void;
  clearCredentials: () => void;
};

const loadFromStorage = (): ResumeCredentials | undefined => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw);
    if (typeof parsed.connectionId === 'string' && typeof parsed.resumeToken === 'string') {
      return { connectionId: parsed.connectionId, resumeToken: parsed.resumeToken };
    }
    return undefined;
  } catch {
    return undefined;
  }
};

export const useHubResumeStore = create<HubResumeState>()((set) => ({
  credentials: loadFromStorage(),

  setCredentials: (credentials) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(credentials));
    } catch {
      // Storage might be full or disabled
    }
    set({ credentials });
  },

  clearCredentials: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // Ignore
    }
    set({ credentials: undefined });
  },
}));
